import { lineString, point } from '@turf/helpers'
import length from '@turf/length'
import { coordAll } from '@turf/meta'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import OLStyleStroke from 'ol/style/Stroke'
import OLStyleStyle from 'ol/style/Style'

import {
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER_SHORTEST,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_MODE,
  setDirectionsTravelDistanceKM,
  setDirectionsTravelDistanceKMShortest
} from 'api/actions'
import * as PoziUtils from 'api/utils'
import AddRoute from 'drawer/tabs/search/panels/AddRoute'

export default function () {
  const state = window.store.getState()
  const startLocation = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION, {})
  const startLocationCoords = get(startLocation, 'coords', [])
  const endLocation = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION, {})
  const endLocationCoords = get(endLocation, 'coords', [])
  const travelMode = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_MODE, '')
  window.store.dispatch(setDirectionsTravelDistanceKM(0))
  window.store.dispatch(setDirectionsTravelDistanceKMShortest(0))

  PoziUtils.gtag({
    category: 'program',
    status: 'success',
    identifier: 'show route',
    action: 'show route for travel mode' + travelMode
  })

  if (travelMode !== '' && startLocationCoords.length === 2 && endLocationCoords.length === 2) {
    if (travelMode === 'shade') {
      const start = point(startLocationCoords)
      const finish = point(endLocationCoords)
      const state = window.store.getState()
      const pathfinder = get(state.config, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER, null)
      const pathFinderShortest = get(state.config, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER_SHORTEST, null)

      if (isNil(pathfinder)) {
        console.log('pathfinder object not set.')
        return
      }
      const path = pathfinder.findPathWithNearbyPoints(start, finish)
      const pathShortest = pathFinderShortest.findPathWithNearbyPoints(start, finish)
      console.log('path', path)
      window.appObject.hideRoute('')

      const numOfFeaturesIsTwo = get(path, 'featureCollection.features', []).length !== 2
      if (isNil(path) || !numOfFeaturesIsTwo) {
        console.log('Show route requires a featureCollection with two features to show path.')
        return
      }

      const styleShortest = new OLStyleStyle({
        stroke: new OLStyleStroke({
          color: 'rgba(255, 0, 0, 0.30)',
          width: 8
        })
      })
      AddRoute(pathShortest.featureCollection, start, finish, styleShortest)

      AddRoute(path.featureCollection, start, finish)

      try {
        const coords = coordAll(path.featureCollection)
        const linestr = lineString(coords)
        const distanceKM = length(linestr)
        window.store.dispatch(setDirectionsTravelDistanceKM(distanceKM))

        const coordsShortest = coordAll(pathShortest.featureCollection)
        const linestrShortest = lineString(coordsShortest)
        const distanceKMShortest = length(linestrShortest)
        window.store.dispatch(setDirectionsTravelDistanceKMShortest(distanceKMShortest))
      } catch (e) {
        console.log(e)
      }
    } else {
      const routing = {
        by: travelMode,
        from: startLocationCoords,
        to: endLocationCoords
      }
      window.appObject.showRoute(routing)
    }
  } else {
    window.appObject.hideRoute('')
  }
}
